import { render, staticRenderFns } from "./TrainingPreview.vue?vue&type=template&id=3c5af3ba&"
import script from "./TrainingPreview.vue?vue&type=script&lang=js&"
export * from "./TrainingPreview.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports